import { css } from '@emotion/css';

import { cn } from '@lyearn/style';

const optionGridColumnsStyles = css`
  grid-template-columns: repeat(auto-fit, minmax(18rem, 1fr));
`;

export const OPTION_LIST_STYLES = cn(
  'flex space-y-10 flex-col items-stretch justify-start native:me-28',
);

const OPTION_GRID_ATTACHMENT_STYLES =
  'xs:flex xs:flex-wrap xs:justify-between xs:items-start w-full grid gap-x-20 gap-y-28';

export const OPTION_GRID_STYLES = cn(OPTION_GRID_ATTACHMENT_STYLES, optionGridColumnsStyles);
